import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ResponsiveTestApp from './responsiveTestApp';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const searchParams = new URLSearchParams(window.location.search);
const RootComponent = searchParams.has('responsiveScenario') ? ResponsiveTestApp : App;

root.render(
  <RootComponent />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
